import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Spinner } from "./components/kit.tsx";
import { Showcase } from "./routes/showcase/Showcase.tsx";
import { Join } from "./routes/showcase/Join.tsx";
import { Activate, SignIn } from "./routes/auth/SignIn.tsx";
import { EmailApproval } from "./routes/auth/EmailApproval.tsx";

// The admin and member workspaces are heavier than the showcase and are not on
// the recruitment path, so they load on demand.
const AdminApp = lazy(() => import("./routes/admin/AdminApp.tsx"));
const MemberApp = lazy(() => import("./routes/member/MemberApp.tsx"));
const NotFound = lazy(() => import("./routes/NotFound.tsx"));

function Loading() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Spinner />
    </div>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Showcase />} />
      <Route path="/join" element={<Join />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/sign-in/admin" element={<SignIn surface="admin" />} />
      <Route path="/activate" element={<Activate />} />
      {/* No session: the token in the fragment is the authorisation. */}
      <Route path="/email-approval" element={<EmailApproval />} />
      <Route
        path="/admin/*"
        element={
          <Suspense fallback={<Loading />}>
            <AdminApp />
          </Suspense>
        }
      />
      <Route
        path="/me/*"
        element={
          <Suspense fallback={<Loading />}>
            <MemberApp />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <Suspense fallback={<Loading />}>
            <NotFound />
          </Suspense>
        }
      />
    </Routes>
  );
}
